/**
 * Where the STATIC H5P bundle (`apps/h5p-core`) is served from.
 *
 * When this resolves to a non-empty value, `fetchH5PPlayerModel` reads the
 * pre-generated player model from `<base>/manifests/<Ubername>.json` and the H5P
 * server is never contacted for PLAYBACK — which is the whole point: no second
 * H5P domain, no cross-origin auth, no runtime Node service in the play path.
 * The H5P server is still needed for the EDITOR (`new/edit`), so `h5pUrl` stays.
 *
 * Resolution order (first non-empty wins):
 *   1. `?h5pStatic=` on the embed URL — lets the host LMS override per embed,
 *      the same way it already overrides `baseUrl` / `h5pUrl`.
 *   2. `VITE_H5P_STATIC_BASE` — the deployed default (e.g. `/h5p-static`).
 *
 * Empty result = feature off, legacy H5P-server path is used unchanged.
 */
export function resolveH5pStaticBase(searchParams?: URLSearchParams): string {
    const fromUrl = searchParams?.get('h5pStatic')?.trim();
    if (fromUrl) {
        return stripTrailingSlash(fromUrl);
    }
    const fromEnv = (import.meta.env.VITE_H5P_STATIC_BASE as string | undefined)?.trim();
    if (fromEnv) {
        return stripTrailingSlash(fromEnv);
    }
    return '';
}

function stripTrailingSlash(value: string): string {
    return value.replace(/\/+$/, '');
}
